// extracted by css-extract-rspack-plugin
export default {"isSelected":"MenuItem-module__isSelected___kbsHx"};